import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/utils/cn'

export const runPageBackgroundClassName =
  'bg-[radial-gradient(circle_at_top_left,rgba(16,185,129,0.12),transparent_28%),radial-gradient(circle_at_top_right,rgba(59,130,246,0.12),transparent_24%),linear-gradient(180deg,rgba(248,250,252,0.98),rgba(240,249,255,0.94))] dark:bg-[radial-gradient(circle_at_top_left,rgba(16,185,129,0.16),transparent_28%),radial-gradient(circle_at_top_right,rgba(59,130,246,0.16),transparent_24%),linear-gradient(180deg,rgba(8,14,18,0.98),rgba(10,20,32,0.96))]'

export const runPageShellClassName = `relative h-full overflow-y-auto ${runPageBackgroundClassName}`

export const runPageContentClassName =
  'mx-auto flex min-h-full w-full max-w-7xl flex-col gap-6 p-6 lg:p-8'

export const runSurfaceClassName =
  'overflow-hidden rounded-[32px] border border-slate-200/80 bg-white/90 shadow-[0_24px_80px_rgba(15,23,42,0.08)] backdrop-blur-sm dark:border-slate-800/80 dark:bg-slate-950/70 dark:shadow-[0_24px_80px_rgba(2,6,23,0.45)]'

export const runHeroBodyClassName =
  'space-y-5 bg-[linear-gradient(135deg,rgba(15,23,42,0.06),transparent_58%),radial-gradient(circle_at_top_right,rgba(16,185,129,0.18),transparent_30%),radial-gradient(circle_at_bottom_left,rgba(59,130,246,0.12),transparent_24%)] px-6 py-7 lg:px-8 dark:bg-[linear-gradient(135deg,rgba(148,163,184,0.08),transparent_58%),radial-gradient(circle_at_top_right,rgba(16,185,129,0.18),transparent_30%),radial-gradient(circle_at_bottom_left,rgba(59,130,246,0.12),transparent_24%)]'

export const runHeroBorderClassName = 'border-b border-slate-200/70 dark:border-slate-800/80'

export const runInsetCardClassName =
  'rounded-2xl border border-slate-200/80 bg-white/80 p-4 shadow-[0_12px_32px_rgba(15,23,42,0.05)] dark:border-slate-800/80 dark:bg-slate-900/80 dark:shadow-[0_12px_32px_rgba(2,6,23,0.4)]'

export const runMetricCardClassName =
  'rounded-[24px] border border-slate-200/80 bg-white/85 p-4 shadow-[0_14px_34px_rgba(15,23,42,0.06)] dark:border-slate-800/80 dark:bg-slate-900/80 dark:shadow-[0_14px_34px_rgba(2,6,23,0.42)]'

export const runMutedPanelClassName =
  'rounded-2xl border border-slate-200/70 bg-slate-50/90 p-4 dark:border-slate-800/80 dark:bg-slate-900/60'

export function RunPageFrame({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div className={cn(runPageShellClassName, className)}>
      <div className={runPageContentClassName}>{children}</div>
    </div>
  )
}

export function RunSurface({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return (
    <section className={cn(runSurfaceClassName, className)} {...props}>
      {children}
    </section>
  )
}

export function RunHero({
  children,
  className,
  bodyClassName,
  divided = false,
  ...props
}: HTMLAttributes<HTMLElement> & {
  bodyClassName?: string
  divided?: boolean
}) {
  return (
    <RunSurface className={className} {...props}>
      <div
        className={cn(
          runHeroBodyClassName,
          divided && runHeroBorderClassName,
          bodyClassName,
        )}
      >
        {children}
      </div>
    </RunSurface>
  )
}
